/**
 * @GENERATED from Figma node 693:15971
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleDocsBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#4285F4"
      fillRule="evenodd"
      d="M3.75 2A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 20.25V3.75A1.75 1.75 0 0 0 20.25 2zm13.875 4.375H6.375v2.5h11.25zM6.375 10.75h11.25v2.5H6.375zm8.125 4.375H6.375v2.5H14.5z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleDocsBright);
export { ForwardRef as GoogleDocsBright };
